export default {
  sys: {
    title: '국립한경대학교 - 통합로그인'
  },

  layout: {
    logo: {
      text: '학사시스템',
      alt: '한경대학교 로고 이미지',
    },
  },

  msgDialog: {
    default: {
      title: {
        alert: '알림',
        confirm: '확인',
      },
      button: {
        yes: '예',
        no: '아니오',
        cancel: '취소',
      }
    }
  },

  loginForm: {
    title: '로그인',
    inputId: {
      ph: '학번 / 사번',
      label: '학번 또는 사번 입력',
    },
    inputPw: {
      ph: '비밀번호',
      label: '비밀번호 입력',
    },
    chkRememId: '학번/사번 저장',
    btnFindId: '학번/사번찾기',
    btnFindPW: '비밀번호찾기',
    btnLogin: '로그인',
    btnDown: '2차인증 APP 다운로드',
    modal: {
      findId: {
        title: '학번/사번 찾기'
      },
      findPw: {
        title: '비밀번호 찾기'
      },
      changePw: {
        title: '비밀번호 변경'
      },
    },
    message: {
      defaultErr: '요청 처리에 실패했습니다.',
      onCapsLock: 'Caps Lock이 켜져있습니다.',
      valid: {
        idEmpty: '학번 또는 사번을 입력하세요',
        pwEmpty: '비밀번호를 입력하세요',
      },
      error: {
        success: '성공',
        idNotFound: '아이디 또는 비밀번호가 틀렸습니다.',
        passwordError: '아이디 또는 비밀번호가 틀렸습니다.',
        alreadySigned: '이미 로그인중인 ID 입니다.',
        blocked: '현재 사용 불가능한 계정입니다.',
        abnormalApproach: '비 정상적 접근입니다.',
        errorCntOver: '비밀번호 오류횟수가 초과되었습니다.',
        expiredPassword: '비밀번호 사용기한이 만료되었습니다.',
        initialPassword: '초기 비밀번호 사용중입니다.',
        limitedIp: '현재 IP에서 사용 불가능한 계정입니다.',
        disagrddPersonalInfo: '개인정보 이용 동의 후 접근 가능합니다.',
        limitedId: '접근 제한된 아이디입니다.',
        expiredId: '사용만료된 계정입니다.',
      }
    }
  },

  idenForm: {
    title: '2차인증',
    touchIcon: {
      alt: '지문모양이미지'
    },
    btnReq: '인증요청',
    btnSubmit: '인증완료',
    tabApp: 'APP 인증',
    tabOtp: 'OTP 인증',
    appForm: {
      noticeMessage: 'App 인증 후 인증완료 버튼을 눌러주세요.',
      error: {
        check2ndFailed: '2차인증에 실패했습니다.',
        proceeding: 'App 인증 후 인증완료 버튼을 눌러주세요.',
        noSign: '2차인증 App을 설치 한 후 다시 로그인해주세요.',
        cancel: '인증 요청이 취소되었습니다.',
        failed: '인증 요청에 실패했습니다.',
        blocked: '인증 차단된 계정입니다.',
      }
    },
    otpForm: {
      noticeMessage: 'OTP 코드 6자리를 입력하세요.',
    }
  },

  pwChangeForm: {
    title: '비밀번호 변경',
    message: {
      success: `비밀번호가 성공적으로 변경되었습니다.
새 비밀번호로 로그인 하시기 바랍니다.`,
      defaultErr: '요청 처리에 실패했습니다.',
      valid: {
        temp: '',
        test00: '길이는 8~20자 사이여야합니다.',
        test01: '공백을 삽입할 수 없습니다.',
        test02: '영문자로 시작해야 합니다.',
        test03: '영문자, 숫자, 특수문자가 모두 포함되어야 합니다.',
        exec00: '해킹에 취약한 문자열({0})을 포함할 수 없습니다.',
        exec01: '4자 이상 연속된 문자열({0})을 포함할 수 없습니다.',
        exec02: '4자 이상 반복 문자([{0}])를 포함할 수 없습니다.',
        comp: '비밀번호와 일치하지 않습니다.'
      },
      error: {
        success: '성공',
      },
    },
    rule: [
      {
        title: '비밀번호 규칙',
        li: [
          {
            txt: '길이는 {0}여야합니다.',
            accent: '8자 ~ 20자 사이',
          },
          {
            txt: '{0} 해야합니다.',
            accent: '영문자로 시작',
          },
          {
            txt: '{0}가 모두 포함되어야 합니다.',
            accent: '영문자, 숫자, 특수문자',
          },
        ]
      },
      {
        title: '다음과 같은 문자열은 포함할 수 없습니다.',
        li: [
          {
            txt: '주민등록번호, 생년월일 등 {0}',
            accent: '사용자 정보',
          },
          {
            txt: '1234, abcd, qwer 등 {0}',
            accent: '연속된 문자열',
          },
          {
            txt: '1111, aaaa 등 {0}',
            accent: '반복 문자열',
          },
          {
            txt: 'password, abc123 등 {0}',
            accent: '해킹에 취약한 문자열',
          },
        ]
      },
    ],
    inputCurPw: {
      ph: '현재 비밀번호',
      label: '현재 비밀번호',
    },
    inputNewPw: {
      ph: '새 비밀번호',
      label: '새 비밀번호',
    },
    inputConfirmPw: {
      ph: '새 비밀번호 확인',
      label: '새 비밀번호 확인',
    },
    btnChange: '변경하기',
  },

  idFindForm: {
    message: {
      defaultErr: '요청 처리에 실패했습니다.',
      success: '요청하신 {0}로 학번/사번이 발송되었습니다.',
      idNotFound: '요청하신 정보에 해당하는 사용자를 찾을 수 없습니다.',
      postEmailFailed: '이메일 발신에 실패했습니다.',
      postSMSFailed: 'SMS 발신에 실패했습니다.',
    },
    noticeMessage: `- 인사/학사정보에 등록된 본인 명의의 이메일, 휴대전화만 이용하실 수 있습니다.
- 입력하신 개인정보는 본인 확인 용도로만 사용됩니다.
- 휴대전화 인증의 경우 통신사 사정으로 메시지를 받지 못하는 경우도 있습니다.`
    ,
    tab: [
      '휴대전화로 찾기',
      'e-mail로 찾기',
    ],
    inputName: '이름',
    inputPhone: '휴대전화번호',
    inputPhoneValid: '* 올바른 휴대전화 양식이 아닙니다.',
    inputEmail: 'e-mail',
    inputEmailValid: '* 올바른 이메일 양식이 아닙니다.',
    btnSubmit: '학번/사번 찾기',
  },

  pwFindForm: {
    message: {
      defaultErr: '요청 처리에 실패했습니다.',
      success: '요청하신 e-mail로 학번/사번이 발송되었습니다.',
      idNotFound: '요청하신 정보에 해당하는 사용자를 찾을 수 없습니다.',
      postEmailFailed: '이메일 발신에 실패했습니다.',
      postSMSFailed: 'SMS 발신에 실패했습니다.',
      invalidToken: '요청 정보에 이상이 있습니다.',
      timeLimited: '입력 시간이 만료되었습니다.',
      invalidCode: '코드가 일치하지 않습니다.',
    },
    noticeMessage: `- 인사/학사정보에 등록된 본인 명의의 이메일, 휴대전화만 이용하실 수 있습니다.
- 입력하신 개인정보는 본인 확인 용도로만 사용됩니다.
- 휴대전화 인증의 경우 통신사 사정으로 메시지를 받지 못하는 경우도 있습니다.`
    ,
    tab: [
      '휴대전화로 인증',
      'e-mail로 인증',
    ],
    inputUserId: '학번/사번',
    inputPhone: '휴대전화번호',
    inputPhoneValid: '* 올바른 휴대전화 양식이 아닙니다.',
    inputEmail: 'e-mail',
    inputEmailValid: '* 올바른 이메일 양식이 아닙니다.',
    btnSubmit: '인증번호발신',
    inputCert: '인증번호',
    btnCret: '확인',
  },

  bbsForm: {
    title: '시스템공지'
  },

  comp: {
    bssFile: {
      title: '첨부파일'
    }
  }
}
